import { render, staticRenderFns } from "./dealerTagList.vue?vue&type=template&id=a1f0c1b4&scoped=true"
import script from "./dealerTagList.vue?vue&type=script&lang=js"
export * from "./dealerTagList.vue?vue&type=script&lang=js"
import style0 from "./dealerTagList.vue?vue&type=style&index=0&id=a1f0c1b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f0c1b4",
  null
  
)

export default component.exports